let lastMsgId = 0;
export default class PromiseWorker {
    w;
    cb = {};
    [Symbol.dispose];
    constructor(worker) {
        this.w = worker;
        const callback = (e) => {
            const payload = e.data;
            const messageId = payload[0];
            const callback = this.cb[messageId];
            if (!callback)
                return;
            delete this.cb[messageId];
            callback(payload[1], payload[2]);
        };
        worker.addEventListener('message', callback);
        this.postMessage = (message, ...extraArgs) => {
            const messageId = lastMsgId++;
            const messageToSend = [messageId, message];
            return new Promise((resolve, reject) => {
                this.cb[messageId] = (error, result) => {
                    if (error) {
                        return reject(new Error(error.message));
                    }
                    resolve(result);
                };
                this.w.postMessage(messageToSend, ...extraArgs);
            });
        };
        this[Symbol.dispose] = () => {
            worker.removeEventListener('message', callback);
        };
    }
    postMessage;
}
